import {AppDispatch} from '../store';

const noOpDispatch: AppDispatch = (() => {}) as AppDispatch;

export default noOpDispatch;
